import React, { useEffect, useState } from 'react';
import { View, Image, ActivityIndicator } from '../../../app-components';
import { invoke } from '../../../AppServices';
import { fullIcon } from '../../../images';
import welcomeTheme from './welcomeTheme';
import { ROUTES } from '../../../Lib/constants';
import { getUserRole } from '../../../Lib/helpers';
import './homescreen.css'

const handleClick = (navigation, cardName, role, data) => {
  if (role === 'superadmin' || role === 'admin') {
    switch (cardName) {
      case 'emailoffer':
        navigation.navigate(ROUTES.emailOfferListSA.name, data);
        break;
      case 'smsoffer':
        navigation.navigate(ROUTES.smsOfferListSA.name, data);
        break;

      case 'printoffer':
        navigation.navigate(ROUTES.printOfferListSA.name, data);
        break;

      case 'avfail':
        navigation.navigate(ROUTES.avFailListSA.name, data);
        break;

      case 'avgenerate':
        navigation.navigate(ROUTES.ARListAvgen.name, data);
        break;

      case 'ucireport':
        navigation.navigate(ROUTES.ARListUCI.name, data);
        break;

      default:
        break;
    }
  }
  console.log('role', role)
  if (role === 'dealer' || role === 'superdealer' || role === 'employee' || role === 'manager') {
    switch (cardName) {
      case 'emailoffer':
        navigation.reset(ROUTES.emailOfferList.name);
        break;
      case 'smsoffer':
        navigation.reset(ROUTES.smsOfferList.name);
        break;

      case 'printoffer':
        navigation.reset(ROUTES.printOfferList.name);
        break;

      case 'avfail':
        navigation.reset(ROUTES.avFailList.name);
        break;

      case 'avgenerate':
        navigation.reset(ROUTES.ARListAvgen.name);
        break;

      case 'ucireport':
        navigation.navigate(ROUTES.ARListUCI.name);
        break;

      default:
        break;
    }
  }
};

const Welcome = (props) => {
  const { navigation, dataParams } = props;
  const [loading, setLoading] = useState(true);
  const [dashboardData, setDashboardData] = useState({
    successCounter: 0,
    failCounter: 0,
    printOfferCounter: 0,
    smsOfferCounter: 0,
    mailOfferCounter: 0,
    uciCounter: 0,
  });
  const [eh, setEH] = useState(false);
  const [sh, setSH] = useState(false);
  const [ph, setPH] = useState(false);
  const [passH, setPassH] = useState(false);
  const [failH, setFailH] = useState(false);
  const [reportH, setReportH] = useState(false);

  const dataForDashboard = async (data) => {
    const { result } = await invoke({
      id: 'dashboardData',
      paramValue: { data },
    });

    setDashboardData(result);
    setLoading(false);
  };

  const userRole = getUserRole();
  console.log('dataParams', dataParams)

  useEffect(() => {
    setLoading(true);
    dataForDashboard(dataParams);
  }, [dataParams]);

  // useEffect(() => {
  //   const regularInterval = setInterval(() => {
  //     if (
  //       navigation.state.routeName === ROUTES.WelcomeSA.name ||
  //       navigation.state.routeName === ROUTES.WelcomeDealer.name
  //     ) {
  //       dataForDashboard(props.dataParams);
  //     }
  //   }, 1000 * 30);
  // }, []);

  return (
    <>
      {loading ? <ActivityIndicator /> : null}
      <View style={welcomeTheme.boxToHoldEverything}>
        <View style={welcomeTheme.boundryBox}>
          <View style={welcomeTheme.boxToHoldAllCards}>
            <View
              onMouseEnter={() => {
                setEH(true);
              }}
              onMouseLeave={() => {
                setEH(false);
              }}
              style={eh ? welcomeTheme.cardBoxHover : welcomeTheme.cardBox}
              onClick={() => handleClick(
                navigation,
                'emailoffer',
                userRole,
                props.dataParams,
              )}
              className='card'
            >
              <View style={welcomeTheme.cardBox20}>
                <View style={welcomeTheme.boxToHoldIcon}>
                  <Image
                    source={fullIcon}
                    style={welcomeTheme.iconProperties}
                  />
                </View>
              </View>
              <View style={welcomeTheme.cardBox80} className="cardBox">
                <View style={welcomeTheme.boxToHoldContent}>
                  <View style={welcomeTheme.boxToHoldNumber}>
                    {dashboardData.mailOfferCounter}
                  </View>
                  <View style={welcomeTheme.boxToHoldText}>
                    EMAIL OFFERS GENERATED
                  </View>
                </View>
              </View>
            </View>

            <View
              onMouseEnter={() => {
                setSH(true);
              }}
              onMouseLeave={() => {
                setSH(false);
              }}
              style={sh ? welcomeTheme.cardBoxHover : welcomeTheme.cardBox}
              onClick={() => handleClick(navigation, 'smsoffer', userRole, props.dataParams)}
              className='card'

            >
              <View style={welcomeTheme.cardBox20}>
                <View style={welcomeTheme.boxToHoldIcon}>
                  <Image
                    source={fullIcon}
                    style={welcomeTheme.iconProperties}
                  />
                </View>
              </View>
              <View style={welcomeTheme.cardBox80} className="cardBox">
                <View style={welcomeTheme.boxToHoldContent}>
                  <View style={welcomeTheme.boxToHoldNumber}>
                    {dashboardData.smsOfferCounter}
                  </View>
                  <View style={welcomeTheme.boxToHoldText}>
                    SMS OFFERS GENERATED
                  </View>
                </View>
              </View>
            </View>

            <View
              onMouseEnter={() => {
                setPH(true);
              }}
              onMouseLeave={() => {
                setPH(false);
              }}
              style={ph ? welcomeTheme.cardBoxHover : welcomeTheme.cardBox}
              onClick={() => handleClick(
                navigation,
                'printoffer',
                userRole,
                props.dataParams,
              )}
              className='card'

           >
              <View style={welcomeTheme.cardBox20}>
                <View style={welcomeTheme.boxToHoldIcon}>
                  <Image
                    source={fullIcon}
                    style={welcomeTheme.iconProperties}
                  />
                </View>
              </View>
              <View style={welcomeTheme.cardBox80} className="cardBox">
                <View style={welcomeTheme.boxToHoldContent}>
                  <View style={welcomeTheme.boxToHoldNumber}>
                    {dashboardData.printOfferCounter}
                  </View>
                  <View style={welcomeTheme.boxToHoldText}>
                    PRINT OFFERS GENERATED
                  </View>
                </View>
              </View>
            </View>

            <View
              onMouseEnter={() => {
                setPassH(true);
              }}
              onMouseLeave={() => {
                setPassH(false);
              }}
              style={passH ? welcomeTheme.cardBoxHover : welcomeTheme.cardBox}
              onClick={() => handleClick(
                navigation,
                'avgenerate',
                userRole,
                props.dataParams,
              )}
              className='card'

            >
              <View style={welcomeTheme.cardBox20}>
                <View style={welcomeTheme.boxToHoldIcon}>
                  <Image
                    source={fullIcon}
                    style={welcomeTheme.iconProperties}
                  />
                </View>
              </View>
              <View style={welcomeTheme.cardBox80} className="cardBox">
                <View style={welcomeTheme.boxToHoldContent}>
                  <View style={welcomeTheme.boxToHoldNumber}>
                    {dashboardData.successCounter}
                  </View>
                  <View style={welcomeTheme.boxToHoldText}>
                    APPRAISED VALUES GENERATED
                  </View>
                </View>
              </View>
            </View>
            
            <View
              onMouseEnter={() => {
                setFailH(true);
              }}
              onMouseLeave={() => {
                setFailH(false);
              }}
              style={failH ? welcomeTheme.cardBoxHover : welcomeTheme.cardBox}
              onClick={() => handleClick(navigation, 'avfail', userRole, props.dataParams)}
              className='card'

            >
              <View style={welcomeTheme.cardBox20}>
                <View style={welcomeTheme.boxToHoldIcon}>
                  <Image
                    source={fullIcon}
                    style={welcomeTheme.iconProperties}
                  />
                </View>
              </View>
              <View style={welcomeTheme.cardBox80} className="cardBox">
                <View style={welcomeTheme.boxToHoldContent}>
                  <View style={welcomeTheme.boxToHoldNumber}>
                    {dashboardData.failCounter}
                  </View>
                  <View style={welcomeTheme.boxToHoldText}>
                    {' '}
                    APPRAISED VALUES NOT GENERATED
                  </View>
                </View>
              </View>
            </View>

            <View
              onMouseEnter={() => setReportH(true)}
              onMouseLeave={() => setReportH(false)}
              style={reportH ? welcomeTheme.cardBoxHover : welcomeTheme.cardBox}
              onClick={() => handleClick(navigation, 'ucireport', userRole, props.dataParams)}
              className='card'

            >
              <View style={welcomeTheme.cardBox20}>
                <View style={welcomeTheme.boxToHoldIcon}>
                  <Image
                    source={fullIcon}
                    style={welcomeTheme.iconProperties}
                  />
                </View>
              </View>
              <View style={welcomeTheme.cardBox80} className="cardBox">
                <View style={welcomeTheme.boxToHoldContent}>
                  <View style={welcomeTheme.boxToHoldNumber}>
                    {dashboardData.uciCounter}
                  </View>
                  <View style={welcomeTheme.boxToHoldText}>
                    CAPTURED APPRAISALS
                  </View>
                </View>
              </View>
            </View>
          </View>
        </View>
      </View>
    </>
  );
};

export default Welcome;
